import type { RemoveItemType } from "../actions/item/remove";

export function getCartItemsData(item: NonNullable<RemoveItemType["data"]>["item"], ga4?: true) {
	return {
		[ga4 ? "item_name" : "name"]: item?.name,
		[ga4 ? "item_id" : "id"]: item?.product?.sku,
		price: item?.totals.price.excludingTax,
		[ga4 ? "item_variant" : "variant"]:
			item?.specs?.__typename === "WoodSpecification" ? item?.specs.shape.code : "",
		quantity: item?.quantity,
	};
}
